import { render } from "./FullscreenChart.vue?vue&type=template&id=4793c742&scoped=true&ts=true"
import script from "./FullscreenChart.vue?vue&type=script&lang=ts"
export * from "./FullscreenChart.vue?vue&type=script&lang=ts"

import "./FullscreenChart.vue?vue&type=style&index=0&id=4793c742&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3546012314/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4793c742"]])

export default __exports__